import { Grid, Typography } from "@mui/material";

const WorklogDetails = ({ data, isMobile }) => (
  <Grid className="worklog-detail">
    <Typography
      className={`worklog-box-name ${isMobile ? "worklog-box-text" : ""}`}>
      {data.username}
      <span className="worklog-status">logged</span>
    </Typography>
    <Typography
      className={`worklog-box-hours ${isMobile ? "worklog-box-text" : ""}`}>
      {`${data?.hour_spent} hours`}
    </Typography>
  </Grid>
);

export default WorklogDetails;
